import React from "react";
import { Provider } from "react-redux";
import { Router } from "react-router";
import PropTypes from "prop-types";

const Root = ({ store, history, routes }) => (
  <Provider store={store}>
    <Router routes={routes} history={history} />
  </Provider>
);

Root.propTypes = {
  store: PropTypes.any,
  history: PropTypes.any,
  routes: PropTypes.any,
};

export default Root;



// WEBPACK FOOTER //
// ./assets/shared/root.jsx